import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const PendingRefundsListView = lazy(() =>
	import('./components/views/PendingRefundsListView').then((m) => ({ default: m.PendingRefundsListView }))
);

/**
 * The Pending Refunds routes.
 */
const pendingRefundsRoutes: FuseRouteItemType[] = [
	{
		path: 'pending-refunds',
		element: <PendingRefundsListView />
	}
];

export default pendingRefundsRoutes;
